import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';

import ScrollTop from 'components/ScrollTop';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  const queryClient = new QueryClient();
  return (
    <ThemeCustomization>
      <QueryClientProvider client={queryClient}>
        <ScrollTop>
          <RouterProvider router={router} />
        </ScrollTop>
      </QueryClientProvider>
    </ThemeCustomization>
  );
}
